var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',[_c('BaseModal',{attrs:{"title":"Import User List","size":"large","noFooter":""},scopedSlots:_vm._u([{key:"openBtn",fn:function(ref){
var openModal = ref.openModal;
return [_c('button',{class:[_vm.$style.bulkInviteLink, 'button'],on:{"click":openModal}},[_vm._v(" "+_vm._s(_vm.text)+" ")])]}},{key:"modalBody",fn:function(ref){
var closeModal = ref.closeModal;
return [_c('InvitationListUploader',{attrs:{"products":_vm.products,"type":_vm.type},on:{"closeModal":closeModal}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }